<div class="modal-header">
  <h4
    i18n="@@preptimeConfirmTitle"
    class="modal-title pull-left"
  >Bitte bestätigen Sie, ob Sie ihre Vorbereitungszeit beginnen möchten</h4>
</div>
<div class="modal-footer">
  <button
    i18n="@@preptimeCancel"
    type="button"
    class="btn btn-default"
    (click)="this.onClose.next(false); bsModalRef.hide()"
  >Abbrechen</button>
  <button
    i18n="@@preptimeConfirm"
    type="button"
    class="btn btn-default"
    (click)="startPrepTime()"
  >Bestätigen</button>
</div>